import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {useTranslation} from '@/translations/i18n'
import {authorizationToLabel, treatmentRequestSectorToLabel, typeToLabel} from '@/features/treatment-requests/utils'
import {
    TreatmentRequestAuthorizationValidationSchema,
    TreatmentRequestExtended
} from '@/features/treatment-requests/types'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {DetailsInformationObservedField} from '@/components/commons/details-information-observed-field/DetailsInformationObservedField'
import {formatDate} from '@/dayjs'
import {z} from 'zod'
import {Text} from '@/components/ui/text/Text'
import {TreatmentRequestProjectResumptionCard} from '@/features/treatment-requests/components/treatment-request-project-resumption-card/TreatmentRequestProjectResumptionCard'

type TreatmentRequestAuthorizationValidationKey = keyof z.infer<typeof TreatmentRequestAuthorizationValidationSchema>

export const TreatmentRequestTreatmentDetails = ({treatmentRequest}: {treatmentRequest: TreatmentRequestExtended}) => {
    const {t} = useTranslation()
    return (
        <Grid columns={3} fullWidth rowGap={4}>
            <GridItem direction="column" gap={1}>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('commons:workSector')}
                </Text>
                <Text weight="500" size="textMd">
                    {t(treatmentRequestSectorToLabel[treatmentRequest.sector])}
                </Text>
            </GridItem>
            <GridItem direction="column" gap={1}>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('commons:authorization')}
                </Text>
                <Flexbox direction="column">
                    <DetailsInformationObservedField<TreatmentRequestAuthorizationValidationKey>
                        name="authorization"
                        hideIcons={['success']}
                        value={
                            treatmentRequest.authorization && (
                                <Text weight="500" size="textMd" palette="neutral" shade="950">
                                    {t(authorizationToLabel[treatmentRequest.authorization])}
                                </Text>
                            )
                        }
                    />
                    {/* Todo: change this label with something else once design will be updated */}
                    <DetailsInformationObservedField<TreatmentRequestAuthorizationValidationKey>
                        name="authorizationDate"
                        hideIcons={['success']}
                        value={
                            treatmentRequest.authorizationDate && (
                                <Text palette="neutral" shade="600" weight="400">
                                    {formatDate(treatmentRequest.authorizationDate, 'DD/MM/YYYY')}
                                </Text>
                            )
                        }
                    />
                </Flexbox>
            </GridItem>
            <GridItem direction="column" gap={1}>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('treatment_requests:request_type')}
                </Text>
                <Text weight="500" size="textMd">
                    {t(typeToLabel[treatmentRequest.type])}
                </Text>
            </GridItem>
            {treatmentRequest.type != 'new_takeover' && (
                <GridItem spanColumn={3}>
                    <TreatmentRequestProjectResumptionCard
                        patientId={treatmentRequest.patientId}
                        type={treatmentRequest.type}
                    />
                </GridItem>
            )}
        </Grid>
    )
}
